import { ManagerApi } from '@idha/idha-api';
import { MANAGER_URL } from "./apiUrls";

const ignoredAlertErrorsUrls = [
    [/api\/People\/[a-z0-9]+\/public-data/, 404]
]

const managerApi = new ManagerApi({
    baseUrl: MANAGER_URL,
    transformRequest: (data, headers) => {
        headers['Authorization'] = headers['Authorization'] || window.localStorage.getItem('$LoopBack$accessTokenId')

        return JSON.stringify(data)
    },
    interceptors: {
        response: [
            {
                onRejected: (e) => {

                    if (ignoredAlertErrorsUrls.find( ([urlRegex, status]) => {
                        return (urlRegex as RegExp).test(e?.config?.baseURL + e?.config?.url) && e?.response?.status == status
                    })  != null) {
                        return
                    }

                    if (e?.response?.data?.error?.status == 400 &&
                            e?.response?.data?.error?.message) {
                        alert(e?.response?.data?.error?.message)
                    } else {
                        alert(`Houve um erro desconhecido. Contacte o suporte idha`)
                    }
                    
                }
            }
        ]
    }
})

export { managerApi }